import styled from '@emotion/styled';


const Hr = styled("div")(({ theme }) => ({
  borderBottom: "1px solid  #39383e",
  width: '100%',
}));

export default Hr;